import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

export const getSkipSetupParts = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return companySettings?.skipSetupParts ?? false;
  }
);
